
import { saveDataSolution } from "../../data/organizationalSolutions";
export default {
  data() {
    return {
      items: saveDataSolution,
      uses: saveDataSolution,
    };
  },
};
